import type { TopluDegerler, TopluKapsamGovdesi } from "./api";
import { baglantiHatasi } from "./gorev-icerigi";

/**
 * HIZLI GİRİŞ — F-SCH-04 / F-SCH-04b (müşteri şablonu, Emre revizesi 04.10.2026)
 *
 * Şablondaki üç grup: Soru / Test · Video · PDF. Ders ve konu burada YOK —
 * şablon "tablodan seçiniz" diyor; hızlı giriş yalnızca mevcut satırlara
 * değer yazıyor.
 *
 * ================================================================
 * BOŞ ALAN "DEĞİŞMEZ" DEMEK, "TEMİZLE" DEĞİL
 * ================================================================
 * Sunucuda gönderilmeyen alan dokunulmuyor, `null` gönderilen alan
 * TEMİZLENİYOR. Ekran boş kutuyu `null` olarak gönderseydi, yalnızca
 * soru sayısı yazıp "Tüm satırlara uygula"ya basan koç haftadaki bütün
 * video ve PDF bağlantılarını silmiş olurdu. Bu yüzden yalnızca DOLU
 * alanlar gövdeye giriyor.
 *
 * Saf modül: React yok, altyapısız test edilir.
 */
export interface HizliGirisFormu {
  soru: string;
  test: string;
  youtube: string;
  videoBasligi: string;
  konuPdf: string;
  testPdf: string;
  not: string;
}

export const BOS_HIZLI_GIRIS: HizliGirisFormu = {
  soru: "",
  test: "",
  youtube: "",
  videoBasligi: "",
  konuPdf: "",
  testPdf: "",
  not: "",
};

export type HizliGirisHatalari = Partial<Record<keyof HizliGirisFormu, string>>;

/** Boş = alan yok; dolu ama pozitif tam sayı değilse `undefined` (hata). */
function pozitifTamSayi(d: string): number | null | undefined {
  const k = d.trim();
  if (k.length === 0) return null;
  const n = Number(k);
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

export function hizliGirisHatalari(f: HizliGirisFormu): HizliGirisHatalari {
  const h: HizliGirisHatalari = {};
  if (pozitifTamSayi(f.soru) === undefined) h.soru = "Pozitif tam sayı olmalı.";
  if (pozitifTamSayi(f.test) === undefined) h.test = "Pozitif tam sayı olmalı.";
  for (const k of ["youtube", "konuPdf", "testPdf"] as const) {
    const hata = baglantiHatasi(f[k]);
    if (hata) h[k] = hata;
  }
  if (f.videoBasligi.trim().length > 200) h.videoBasligi = "En fazla 200 karakter.";
  if (f.not.trim().length > 2000) h.not = "En fazla 2000 karakter.";
  return h;
}

/** Yalnızca DOLU alanlar — yukarıdaki "boş değişmez" kuralı. */
export function hizliGirisDegerleri(f: HizliGirisFormu): TopluDegerler {
  const d: TopluDegerler = {};
  const soru = pozitifTamSayi(f.soru);
  const test = pozitifTamSayi(f.test);
  if (typeof soru === "number") d.targetQuestionCount = soru;
  if (typeof test === "number") d.targetTestCount = test;
  const metin = (v: string) => v.trim();
  if (metin(f.youtube)) d.youtubeUrl = metin(f.youtube);
  if (metin(f.videoBasligi)) d.videoTitle = metin(f.videoBasligi);
  if (metin(f.konuPdf)) d.topicPdfUrl = metin(f.konuPdf);
  if (metin(f.testPdf)) d.testPdfUrl = metin(f.testPdf);
  if (metin(f.not)) d.coachNote = metin(f.not);
  return d;
}

export type HizliGirisKapsami =
  | { tur: "secili"; gorevIdler: readonly string[] }
  | { tur: "gun"; tarih: string }
  | { tur: "hafta" };

/**
 * Sunucunun kapsam gövdesi — tür AÇIKÇA yazılır (F-SCH-04b). Sunucu
 * türsüz ya da belirsiz kapsamı 400 ile reddediyor; eskiden `kapsam: {}`
 * sessizce BÜTÜN HAFTA demekti. Seçili kapsam boş diziyle ASLA
 * gönderilmiyor.
 */
export function kapsamGovdesi(k: HizliGirisKapsami): TopluKapsamGovdesi {
  if (k.tur === "secili") {
    if (k.gorevIdler.length === 0) throw new Error("Seçili görev yok.");
    return { tur: "secili", gorevIdler: [...k.gorevIdler] };
  }
  if (k.tur === "gun") return { tur: "gun", tarih: k.tarih };
  return { tur: "hafta" };
}
